module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-json-conf"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.json),
      expression: "json"
    }],
    staticStyle: {
      "font-family": "Monospace"
    },
    attrs: {
      "rows": "20"
    },
    domProps: {
      "value": (_vm.json)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.json = $event.target.value
      }, _vm.updateValue]
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cfbae5c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/JsonConf.vue
// module id = 2526
// module chunks = 1